import React, { useRef } from "react"
import { Cylinder, Sphere, Torus } from "@react-three/drei"
import PropTypes from "prop-types"
import { useFrame } from "@react-three/fiber"
import * as THREE from "three"

const Visibility = (props) => {
  const ref = useRef()
  const torusRef = useRef()
  const dumbellRef = useRef()

  useFrame((state) => {
    const t = state.clock.getElapsedTime()
    ref.current.position.z = Math.sin(t) * props.valueNeph * 2 * -1
    ref.current.rotation.x = Math.sin(t) * props.valueNeph * 10
    dumbellRef.current.scale.y = Math.sin(-t) * 0.5 + 0.75
    dumbellRef.current.rotation.y = t
    torusRef.current.rotation.y = -t
  })

  const torusMaterial = new THREE.MeshPhysicalMaterial({
    color: new THREE.Color(
      `hsl(${THREE.MathUtils.mapLinear(
        props.valuePm10,
        0,
        1,
        150,
        250
      )}, 100%, 75%)`
    ).convertSRGBToLinear(),
    roughness: 0,
    clearcoat: 1,
    clearcoatRoughness: 0,
  })

  const dumbellMaterial = new THREE.MeshPhysicalMaterial({
    color: new THREE.Color(
      `hsl(${THREE.MathUtils.mapLinear(
        props.valuePm10,
        0,
        1,
        0,
        100
      )}, 100%, 75%)`
    ).convertSRGBToLinear(),
    roughness: 0,
    clearcoat: 1,
    clearcoatRoughness: 0,
  })

  return (
    <group scale={props.valueNeph / 4 + 0.25} position={[props.xPos, 0, 0]}>
      {/* Top sphere and cylinder */}
      <group ref={ref}>
        <group scale={0.9}>
          <group ref={dumbellRef}>
            <Sphere
              scale={[1.125, 0.75, 0.75]}
              position={[0, 1.25, 0]}
              material={dumbellMaterial}
            />
            <Cylinder args={[0.2, 0.2, 2]} material={dumbellMaterial} />
            <Sphere
              scale={[1.125, 0.75, 0.75]}
              position={[0, -1.25, 0]}
              material={dumbellMaterial}
            />
          </group>
          <group ref={torusRef}>
            <Torus
              scale={[0.15, 0.1, 0.1]}
              rotation={[-Math.PI / 2, 0.1, 0.1]}
              args={[8, 1.5, 16, 100]}
              material={torusMaterial}
            />
          </group>
        </group>
      </group>
    </group>
  )
}

Visibility.propTypes = {
  xPos: PropTypes.number,
  animationSpeed: PropTypes.number,
  scale: PropTypes.number,
  donutColor: PropTypes.string,
  topSphereColor: PropTypes.string,
  cylinderColor: PropTypes.string,
}

Visibility.defaultProps = {
  xPos: 0,
  animationSpeed: 1,
  scale: 0.4,
  donutColor: "blue",
  topSphereColor: "green",
  cylinderColor: "yellow",
}

export default Visibility
